import { render, staticRenderFns } from "./FireequipmentIndex.vue?vue&type=template&id=21972003&scoped=true&"
import script from "./FireequipmentIndex.vue?vue&type=script&lang=js&"
export * from "./FireequipmentIndex.vue?vue&type=script&lang=js&"
import style0 from "./FireequipmentIndex.vue?vue&type=style&index=0&id=21972003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21972003",
  null
  
)

export default component.exports